module.exports = __webpack_public_path__ + "img/SPO2_REPORT_TEMPLATE_1_DOCTOR_SIGNATURE.a3fc7783.png";